var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6673 7.99996C14.6673 4.31806 11.6826 1.33329 8.00065 1.33329C4.31875 1.33329 1.33398 4.31806 1.33398 7.99996C1.33398 11.3275 3.77189 14.0855 6.95898 14.5856V9.92704H5.26628V7.99996H6.95898V6.53121C6.95898 4.86037 7.95427 3.93746 9.47708 3.93746C10.2065 3.93746 10.9694 4.06766 10.9694 4.06766V5.70829H10.1287C9.30059 5.70829 9.04232 6.22218 9.04232 6.7494V7.99996H10.8913L10.5957 9.92704H9.04232V14.5856C12.2294 14.0855 14.6673 11.3275 14.6673 7.99996Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.8db9220c58e6d5700c8d30301a9bc643.svg";
export { ForwardRef as ReactComponent };